
import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';


interface IUserInfo {
    acceptStatus: string;
    companyId: string;
    credential: any;
    departmentId: string;
    departmentName: string;
    description: string;
    email: string;
    gUserId: string;
    isActivated: boolean;
    isDeleted: boolean;
    lastLoginIp: string;
    lastLoginTime: number;
    nickName: string;
    phone: string;
    userId: string;
    userType: string;
}

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    carouselboxContent: any;
    // 选择人员打开的tab标识
    public setPowerData: any = {};
    openTabVisible: string = 'companyUser';
    spinningVisible: boolean = false;
    companyUserFilterList: IUserInfo[] = [];
    companyUserSearch: string = '';
    departmentSearch: string = '';
    teamworkUserSearch: string = '';
    // 部门列表 筛选后tree数据
    departmentFilterList: any[] = [];
    // 协同人员列表，筛选后tree数据
    departmentFilterListByTeamwork: any[] = [];
    departmentFilterListByCommanyUser: any[] = [];
    domTree: any = null;
    treeId: any = '';
    activeUserObjects: any[] = [];
    activeDepObjects: any[] = [];
    /** 应用基本信息 */
    public appInfo: {
        appCompany: string;
        appDescription: string;
        appIcon: string;
        appId: number;
        appIndexUri: string;
        appIntroduction: string;
        appInstanceAK: string;
        appInstanceSK: string;
        appType: number;
        appKey: string;
        appName: string;
        categoryName: string;
        isActivated: number;
        appSecret: string;
    } = {
            appCompany: '',
            appDescription: '',
            appIcon: '',
            appId: 0,
            appIndexUri: '',
            appIntroduction: '',
            appKey: '',
            appName: '',
            categoryName: '',
            isActivated: 0,
            appInstanceAK: '',
            appInstanceSK: '',
            appType: undefined,
            appSecret: undefined,
        };
    public tabchange: string;
    /** 实例权限列表: 用户 */
    permissionUserObjects: {
        [key: string]: {
            objectId: string;
            objectName?: string;
            objectType: number;
            objectUniqueKey?: string;
        }[]
    } = {};
    /** 实例权限列表: 部门 */
    permissionDepObjects: {
        [key: string]: {
            objectId: string;
            objectName?: string;
            objectType: number;
            objectUniqueKey?: string;
        }[]
    } = {};
    /** 被勾选的部门值 */
    permissionDepObjectsValues: Array<number | string> = [];
    /** 查询公司人员 */
    companyUserParam: {
        nickName: string;
        email: string;
        pageNum: number;
        pageSize: number;
    } = {
            nickName: '',
            email: '',
            pageNum: 1,
            pageSize: 10,
        };
    /** 公司人员 */
    companyUserList: IUserInfo[] = [];
    public departmentQuery: {
        createTime: number,
        departmentId: string,
        description: string,
        isDeleted: boolean,
        name: string,
        number: string,
        parentDepartmentId: string,
        updateTime: number
    }[];
    /** 公司人员分页 信息 */
    pageMeta: {
        pageNum: number;
        pageSize: number;
        pages: number;
        total: number;
    } = {
            pageNum: 0,
            pageSize: 0,
            pages: 0,
            total: 0,
        };
    public departtreeDate: any[];
    /** app类型 */
    public appCategoryList: {
        categoryId: number;
        categoryName: string;
    }[] = [];
    categoryList: Array<{ // 应用类型列表
        categoryId: number;
        categoryName: string;
    }>;
    /** 选中的app类型 */
    public appCategory: number = 0;
    /** 私有应用 公有 所有 */
    public isOpen: string = 'all';
    public isOpenList: Array<{
        name: string;
        id: string;
    }> = [
            { id: 'all', name: '全部应用' },
            { id: '1', name: '公开应用' },
            { id: '0', name: '私有应用' },
            { id: 'myApp', name: '我的应用' },
        ];
    /** 分页信息 设置 */
    public pageNum: number = 1;
    public pageSize: number = 12;
    public total: number = 0;

    /** app列表 */
    public appList: {
        appDescription: string; // 应用描述
        appIntroduction:string; // y应用简介
        appIcon: string;
        appId: number;
        appIndexUri: string;
        appKey: string;
        appName: string
        categoryName: string;
        isActivated: number;
        appType:number;
    }[] = [];
    /** 模糊搜索 */
    searchInfo: {
        appName?: string;
        appCategoryId?: any;
        appDescription?: string;
        isOpen?: string;
    } = {
            appName: '',
            appCategoryId: '',
            appDescription: '',
            isOpen: 'all'
        };
    search: string;
    screenListData: any[];
    type: string;

    appKey: any;
    checkedAppList: Set<number> = new Set();

    /** 激活弹框 */
    public activTipsM: boolean = false;
    public isReadCheckd: boolean = false;
    public appCategories: Array<any> = [];
    public appAgreementContent: string;
    drawerDetailsVisible: boolean = false;
    agreeReactDom: any;
    checkcedAgreeList: Set<any> = new Set(); // 选择协议的set
    isCheckcedAgreeAll: boolean = false;
    //常用是否已经全选
    isCheckedAll: boolean = false;
    itemDetaials: any = {};
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/AppBatchSetPower/Modules.State.ts